export class CsvPayload {
  constructor(private readonly headers: string[], private readonly data: string[][]) {}

  getHeaders() {
    return this.headers;
  }

  getData() {
    return this.data;
  }
}
